export const HEADER_MENUS = [
    {
        label: 'ScriptDoor for you',
        isExpanded: false,
        submenus: [
            {
                link: '/the-explorer',
                label: 'The Explorer'
            },
            {
                link: '/the-creator',
                label: 'The Independent Creator'
            },
            {
                link: '/the-big-entertainer',
                label: 'The Big Entertainer'
            },
            {
                link: '/the-screener',
                label: 'The Screener'
            }

        ]
    },
    {
        label: 'Product',
        isExpanded: false,
        submenus: [
            {
                link: '/features',
                label: 'Features'
            },
            {
                link: '/pricing',
                label: 'Pricing'
            },
            {
                link: '/faq',
                label: 'FAQs'
            }
        ]
    },
    {
        label: 'About',
        isExpanded: false,
        submenus: [
            {
                link: '/our-story',
                label: 'Our story'
            },
            {
                link: '/how-it-works',
                label: 'How we work'
            },
            {
                link: '/events',
                label: 'Events'
            },
            {
                link: '/careers',
                label: 'Careers'
            },
            {
                link: '/contact-us',
                label: 'Contact us'
            }
        ]
    }
];
